import Page from "../pages/Privacy";
import { pageMeta } from "../lib/meta";
export const meta = () => pageMeta({ title: "Privacy Policy | Gazar", description: "Privacy Policy for gazar.dev operated by QUEEK LIMITED", path: "/privacy" });
export default function Privacy() { return <Page />; }
